export function searchFormat(searchObj) {
  let searchArr = [];
  if (searchObj) {
    for (let key in searchObj) {
      if (searchObj[key].name === undefined) {
        searchObj[key].name = key;
      }
      if(searchObj[key].value != ""){
        searchArr.push(searchObj[key]);
      }
    }
  }
  return JSON.stringify(searchArr);
}



// WEBPACK FOOTER //
// ./src/common/utils/SearchUtils.js